import { HttpHeaders } from '@angular/common/http';
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { ChangeDatetimeReshopReprice } from 'src/app/model/request/change-date-time-reshop-reprice-request';
import { FindOrderScreenRequest } from 'src/app/model/request/find-order-screen-request';
import { OfferPriceScreenOrderCreateRequest } from 'src/app/model/request/offer-price-screen-order-create-request';
import { OrderChangeIssueTicketRequest, Passenger as orderChangePassenger } from 'src/app/model/request/order-change-issue-ticket-request';
import {
  Passenger as PassengerSeatSelection,
  SBody as SBodySeatSelection,
  SeatAvailabilityRQ,
  SeatSelectionScreenRequest,
  SEnvelope as SEnvelopeSeatSelection
} from 'src/app/model/request/seat-selection-screen-request';
//import { CancelBookingGetRefundScreen } from 'src/app/model/screen/cancel-booking-get-refund';
import { FindOrdersScreen } from 'src/app/model/screen/find-order-screen';
import {
  AdditionalCouponInfo,
  CouponInfo,
  Passenger as passengerScreenPassenger,
  PassengerDetailScreen,
  PassengerSeatDetails,
  PassengerServiceDetails,
  PassengerTicketDetail,
  TaxDetails
} from 'src/app/model/screen/passenger-detail-screen';
import { SeatSelectionScreen } from 'src/app/model/screen/seat-selection-screen';
import {
  AirlineOfferBase,
  Booking,
  BoundAirlineOffer,
  FlightDetail,
  orderCreateViewRules,
  OrderItem,
  PassengerSeatDetail as YourBookingScreenFlightPassengerSeatDetail,
  Rule,
  services,
  YourBookingScreen
} from 'src/app/model/screen/your-booking-screen';
import { DateFormatPipe } from 'src/app/pipe/date-format.pipe';
import { ApiService } from 'src/app/service/api.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import reQuoteTicketJSON from 'src/assets/json/order-change/request/requote-ticket-default-params.json';

@Component({
  selector: 'app-your-booking-screen',
  templateUrl: './your-booking-screen.component.html',
  styleUrls: ['./your-booking-screen.component.scss']
})
export class YourBookingScreenComponent implements OnInit {
  yourBookingScreen: YourBookingScreen = {} as YourBookingScreen;
  //cancelBookingGetRefundScreen: CancelBookingGetRefundScreen = {} as CancelBookingGetRefundScreen;
  orderChangeRemoveSeat: OrderChangeIssueTicketRequest = {} as OrderChangeIssueTicketRequest;
  orderChangeInputParams = new Map();
  yourBookingScreenOrderView: any;
  airlineLogos: [] = [];
  isSMEUser: boolean = false;

  constructor(
    private sandboxPageStateService: SandboxPageStateService,
    private apiService: ApiService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private datePipe: DateFormatPipe,
    private localAssetReaderService: LocalAssetReaderService,
    private contentfulService: ContentfulService
  ) {
    Object.entries(reQuoteTicketJSON).forEach((entry) => {
      const [key, value] = entry;
      this.orderChangeInputParams.set(key, value);
    });
    const query = { 'fields.name': 'Airline Logos#SANDBOX' };
    this.contentfulService.getMenuContentWithItems(query).then((items) => {
      this.airlineLogos = items[0]?.fields.jsonData;
      if (this.airlineLogos && Object.keys(this.airlineLogos).length > 0) {
        Object.entries(this.airlineLogos).forEach((entry) => {
          const [key, value] = entry;
          this.flightLogoMap.set(key, value);
        });
      }
    });
  }

  //  public isYourBookingScreenMapped: boolean = false;
  public flightRefIds: any = [];
  public flightRefIdsNotUN: any = [];
  public flightsDetails: any = [];
  public targetRule: any = '';
  //  public orderItemIds: any = [];
  public orderItemList: any = [];
  public yourBookingScreenDataLists: any = [];
  public yourBookingFareRules: any = [];
  public fareRulesIds: any = [];
  public fareRulesSegmentList: any = [];
  public rulesIds: any = [];
  public rulesList: any = [];
  public destinationList: any = [];
  public serviceDefinationListIds: any = [];
  public serviceDefinationList: any = [];
  public ticketDocsList: any = [];
  public yourBookingScreenBookingType: 'pre-booking' | 'post-booking-reshop' | 'post-booking' = 'pre-booking';
  public booking: Booking = {} as Booking;
  public passengerDetailScreenData: PassengerDetailScreen = {} as PassengerDetailScreen;

  public penaltyRulesIds: any = [];

  public offerItemIds: any = [];

  public orderCreateViewRules: orderCreateViewRules = {} as orderCreateViewRules;
  public airlineOfferBase: AirlineOfferBase = {} as AirlineOfferBase;

  public seatServiceRefs: any = [];
  public seatServiceList: any = [];
  public seatOfferIdList: any = [];
  flightLogoMap = new Map();
  //add seat variable
  seatSelectionScreenRequest: SeatSelectionScreenRequest = {} as SeatSelectionScreenRequest;
  //end
  public cancelSeatSelectedBoundIndex: any;
  public cancelSeatSelectedFlightIndex: any;
  ngOnInit(): void {
    this.isSMEUser = this.sandboxPageStateService.getUser().isSMEUser;
    this.yourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    if (this.yourBookingScreen.bookingType === 'post-booking-reshop') {
      let yourBookingScreenJsonData = this.yourBookingScreen.jsonData;
      let yourBookingScreenEnvelop = yourBookingScreenJsonData['SOAP:ENVELOPE'];
      let yourBookingScreenBody = yourBookingScreenEnvelop['SOAP:BODY'][0];
      if(yourBookingScreenBody['ORDERVIEWRS'])
            this.initYourBookingScreenMapping();
        else
      this.initYourReshopBookingScreenMapping();
    }   else {
      this.initYourBookingScreenMapping();
    }
  }

  mapCancelBookingRefundData(reQuoteCancelBookingGetRefundJSONData: any) {
    if (reQuoteCancelBookingGetRefundJSONData) {
      let cancelBookingGetRefundEnvelop = reQuoteCancelBookingGetRefundJSONData['SOAP:ENVELOPE'];
      let cancelBookingGetRefundEnvelopBody = cancelBookingGetRefundEnvelop['SOAP:BODY'][0];
      let cancelBookingGetRefundOrderShopViews = cancelBookingGetRefundEnvelopBody['ORDERRESHOPRS'][0];
      let cancelBookingGetRefundOrderShopResponse = cancelBookingGetRefundOrderShopViews['RESPONSE'][0];
      let cancelBookingGetRefundReshopOffer = cancelBookingGetRefundOrderShopResponse['RESHOPOFFERS'][0]['RESHOPOFFER'][0];
      let cancelBookingGetRefundDataLists = cancelBookingGetRefundOrderShopResponse['DATALISTS'][0];
      let cancelBookingGetRefundPassengerDetails = cancelBookingGetRefundDataLists['PASSENGERLIST'][0]['PASSENGER'];
      let cancelBookingGetRefundSimpleCurrencyCode = cancelBookingGetRefundReshopOffer.TOTALPRICE[0].SIMPLECURRENCYPRICE[0].$.CODE;
      let cancelBookingGetRefundSimpleCurrencyPrice = cancelBookingGetRefundReshopOffer.TOTALPRICE[0].SIMPLECURRENCYPRICE[0]._;
      let totalPrice = cancelBookingGetRefundReshopOffer['TOTALPRICE'][0]['SIMPLECURRENCYPRICE'][0]._;
      let priceCode = cancelBookingGetRefundReshopOffer['TOTALPRICE'][0]['SIMPLECURRENCYPRICE'][0].$.CODE;
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let pnrNumber = yourBookingScreenDetail.booking?.pnrNumber;
    }
  }
  initYourBookingScreenMapping() {
    // this function handle two different ressponse. one is from find order search and other order create (prime booking)
    if (this.yourBookingScreen.jsonData) {
      if (!this.yourBookingScreen.isMapped) {
        this.yourBookingScreenBookingType = this.yourBookingScreen.bookingType;

        let yourBookingScreenJsonData = this.yourBookingScreen.jsonData;
        let yourBookingScreenEnvelop = yourBookingScreenJsonData['SOAP:ENVELOPE'];
        let yourBookingScreenBody = yourBookingScreenEnvelop['SOAP:BODY'][0];
        this.yourBookingScreenOrderView = yourBookingScreenBody['ORDERVIEWRS'][0];
        let yourBookingScreenOrderResponse = this.yourBookingScreenOrderView['RESPONSE'][0];
        this.yourBookingScreenDataLists = yourBookingScreenOrderResponse['DATALISTS'][0];
        let yourBookingScreenOrderData = yourBookingScreenOrderResponse['ORDER'][0];
        let yourBookingScreenOrderItems = yourBookingScreenOrderData['ORDERITEMS'];
        let flightSegmentList = this.yourBookingScreenDataLists['FLIGHTSEGMENTLIST'][0]['FLIGHTSEGMENT'];
        let yourBookingScreenOrderItem = yourBookingScreenOrderData.ORDERITEMS[0].ORDERITEM;
        this.orderItemList = yourBookingScreenOrderItem;
        this.mapOrderItemIds(this.orderItemList);
        if (typeof this.yourBookingScreenDataLists.PENALTYLIST !== 'undefined') {
          this.rulesList = this.yourBookingScreenDataLists.PENALTYLIST[0].PENALTY;
          this.mapPenaltyIds(this.rulesList);
        }
        if (typeof this.yourBookingScreenDataLists.SERVICEDEFINITIONLIST !== 'undefined') {
          this.serviceDefinationList = this.yourBookingScreenDataLists.SERVICEDEFINITIONLIST[0].SERVICEDEFINITION;
          this.mapServiceDeinationIds(this.serviceDefinationList);
        }

        if (typeof yourBookingScreenOrderResponse.TICKETDOCINFOS !== 'undefined') {
          this.ticketDocsList = yourBookingScreenOrderResponse.TICKETDOCINFOS[0].TICKETDOCINFO;
        }
        // TicketDocInfos
        this.destinationList = this.yourBookingScreenDataLists.ORIGINDESTINATIONLIST[0].ORIGINDESTINATION;
        if (typeof yourBookingScreenOrderItem[0].PENALTY !== 'undefined') {
          this.penaltyRulesIds = yourBookingScreenOrderItem[0].PENALTY[0].$.REFS.split(' ');
        } else {
          if (this.yourBookingScreenBookingType === 'pre-booking' || this.yourBookingScreenBookingType === 'post-booking') {
            if (typeof yourBookingScreenOrderItem[0].FAREDETAIL !== 'undefined') {
              this.fareRulesSegmentList = yourBookingScreenOrderItem[0].FAREDETAIL[0].FARECOMPONENT;
              if (typeof this.fareRulesSegmentList !== 'undefined') {
                this.mapFareRulesId(this.fareRulesSegmentList);
              }
            }
          }
        }
        this.mapFlightIds(flightSegmentList);

        // this.mapOrderItems(yourBookingScreenOrderItem);
        this.flightsDetails = flightSegmentList;

        this.mapYourBookingScreen(yourBookingScreenOrderData);
      } else {
        this.yourBookingScreenBookingType = this.yourBookingScreen.bookingType;
      }
    } else {
      // console.log('this.yourBookingScreen.jsonData is undefined');
    }
  }
  initYourReshopBookingScreenMapping() {
    if (this.yourBookingScreen.jsonData) {
      if (!this.yourBookingScreen.isMapped) {
        this.yourBookingScreenBookingType = this.yourBookingScreen.bookingType;

        let yourBookingScreenJsonData = this.yourBookingScreen.jsonData;
        let yourBookingScreenEnvelop = yourBookingScreenJsonData['SOAP:ENVELOPE'];
        let yourBookingScreenBody = yourBookingScreenEnvelop['SOAP:BODY'][0];
        let yourBookingScreenOrderView = yourBookingScreenBody['ORDERRESHOPRS'][0];
        let yourBookingScreenOrderResponse = yourBookingScreenOrderView['RESPONSE'][0];
        this.yourBookingScreenDataLists = yourBookingScreenOrderResponse['DATALISTS'][0];
        let yourBookingScreenOrderData = yourBookingScreenOrderResponse['RESHOPOFFERS'][0];
        //let yourBookingScreenOrderItems = yourBookingScreenOrderData['ORDERITEMS'];
        let flightSegmentList = this.yourBookingScreenDataLists['FLIGHTSEGMENTLIST'][0]['FLIGHTSEGMENT'];
        let yourBookingScreenOrderItem = yourBookingScreenOrderData.RESHOPOFFER[0].ADDOFFERITEM;
        this.orderItemList = yourBookingScreenOrderItem;
        this.mapReshopOfferItemIds(this.orderItemList);
        if (typeof this.yourBookingScreenDataLists.PENALTYLIST !== 'undefined') {
          this.rulesList = this.yourBookingScreenDataLists.PENALTYLIST[0].PENALTY;
          this.mapPenaltyIds(this.rulesList);
        }
        if (typeof this.yourBookingScreenDataLists.SERVICEDEFINITIONLIST !== 'undefined') {
          this.serviceDefinationList = this.yourBookingScreenDataLists.SERVICEDEFINITIONLIST[0].SERVICEDEFINITION;
          this.mapServiceDeinationIds(this.serviceDefinationList);
        }

        if (typeof yourBookingScreenOrderResponse.TICKETDOCINFOS !== 'undefined') {
          this.ticketDocsList = yourBookingScreenOrderResponse.TICKETDOCINFOS[0].TICKETDOCINFO;
        }
        // TicketDocInfos
        this.destinationList = this.yourBookingScreenDataLists.ORIGINDESTINATIONLIST[0].ORIGINDESTINATION;
        if (typeof yourBookingScreenOrderItem[0].PENALTY !== 'undefined') {
          this.penaltyRulesIds = yourBookingScreenOrderItem[0].PENALTY[0].$.REFS.split(' ');
        }

        this.mapFlightIds(flightSegmentList);

        // this.mapOrderItems(yourBookingScreenOrderItem);
        this.flightsDetails = flightSegmentList;
        this.mapYourReshopBookingScreen(yourBookingScreenOrderData);
      } else {
        this.yourBookingScreenBookingType = this.yourBookingScreen.bookingType;
      }
    }
  }

  mapYourBookingScreen(yourBookingScreenOrderData: any) {
    this.booking = {} as Booking;
    let bookingStatus = '';
    let boundAirlineOffers: BoundAirlineOffer[] = [];
    let currency = '';
    let serviceItemList: services[] = [];
    let boundFlightList = this.yourBookingScreenDataLists['FLIGHTLIST'][0]['FLIGHT'];
    let boundFlightSegmentList = this.yourBookingScreenDataLists['FLIGHTSEGMENTLIST'][0]['FLIGHTSEGMENT'];
    let boundFlightListLength = boundFlightList.length;
    let OriginDestinationList = this.yourBookingScreenDataLists['ORIGINDESTINATIONLIST'];
    let pnrNumber = yourBookingScreenOrderData.$.ORDERID;
    let bookingAgent = yourBookingScreenOrderData.$.OWNER;
    let yourBookingOrderItem = yourBookingScreenOrderData.ORDERITEMS[0].ORDERITEM[0];
    let yourBookingOrderItemList = yourBookingScreenOrderData.ORDERITEMS[0].ORDERITEM;

    let paymentTimeLimit: any = '';
    if (typeof yourBookingOrderItem.TIMELIMITS !== 'undefined') {
      let paymentLimit: any = yourBookingOrderItem.TIMELIMITS[0].PAYMENTTIMELIMIT[0].$.TIMESTAMP;
      //let paymentLimtDateFormat:any = new Date(paymentLimit);
      let paymentLimitLastLetter: any = paymentLimit.slice(-1);
      if (paymentLimitLastLetter === 'Z') {
        paymentLimit = paymentLimit.slice(0, -1);
      }
      (paymentTimeLimit = this.datePipe.transform(paymentLimit, 'd-MMM-y h:mm')), (bookingStatus = 'HOLD');
    }
    if (boundFlightListLength > 0) {
      boundFlightList.forEach((boundFlight: any) => {
        let boundAirlineOffer = {} as BoundAirlineOffer;
        boundAirlineOffer = this.mapFlightDetails(boundFlight.SEGMENTREFERENCES[0], boundFlightSegmentList);
        let orginDestinationKey = '';
        this.destinationList.forEach((destination: any) => {
          let flightRefArr = destination.FLIGHTREFERENCES[0].split(' ');
          let flightRefIndex: any = flightRefArr.indexOf(boundFlight.$.FLIGHTKEY);
          if (flightRefIndex !== -1) {
            orginDestinationKey = destination.$.ORIGINDESTINATIONKEY;
          }
        });
        boundAirlineOffer.originDestinationKey = orginDestinationKey;
        boundAirlineOffer.depatureAirportCode = this.destinationList[0].DEPARTURECODE[0];
        boundAirlineOffer.arrivalAirportCode = this.destinationList[0].ARRIVALCODE[0];
        boundAirlineOffer.depatureDate = boundAirlineOffer.flightsDetails[0].segmentDepartureDate;
        boundAirlineOffers.push(boundAirlineOffer);
      });
      if (bookingStatus !== 'HOLD') {
        let isCancelled: boolean = false;
        let isConfirmed: boolean = false;
        boundAirlineOffers.forEach((boundAirlineOffer: BoundAirlineOffer) => {
          if (boundAirlineOffer.boundFlightStatus === 'Confirmed') {
            isConfirmed = true;
          } else if (boundAirlineOffers[0].boundFlightStatus === 'Cancelled') {
            isCancelled = true;
          }
        });
        if (isCancelled) {
          bookingStatus = 'CANCELLED';
        } else {
          bookingStatus = 'CONFIRMED';
        }
        /*if (boundAirlineOffers[0].boundFlightStatus === 'Confirmed') {
          bookingStatus = 'CONFIRMED';
        } else if (boundAirlineOffers[0].boundFlightStatus === 'Cancelled') {
          bookingStatus = 'CANCELLED';
        }*/
      }
      let totalTax = 0;
      let totalPrice = 0;
      let totalBasePrice = 0;
      let yourBookingPassengerList = this.yourBookingScreenDataLists.PASSENGERLIST[0].PASSENGER;
      let yourBookingPassengerListLength = yourBookingPassengerList.length;
      let passengerDetails: passengerScreenPassenger[] = [];
      let OrderItemID: OrderItem[] = [];
      let flightsRefs = this.flightRefIds.join('-');
      let flightRefIdsNotUN = this.flightRefIdsNotUN.join('-');
      if (this.flightRefIdsNotUN.length === 0) {
        flightRefIdsNotUN = flightsRefs;
      }
      let yourBookingFlightPrice: any = 0;
      let yourBookingTaxPrice: any = 0;
      let yourBookingTotalPrice: any = 0;

      if (yourBookingPassengerListLength > 0) {
        yourBookingPassengerList.forEach((passenger: any) => {
          let passengerContactDetail = passenger.INDIVIDUAL[0];
          let passengerId = passenger.$.PASSENGERID;

          let passengerBaggageDetails: PassengerServiceDetails[] = [];
          let passengerSeatDetails: PassengerSeatDetails[] = [];
          let passengerMealDetails: PassengerServiceDetails[] = [];
          let passengerDisablityServiceDetail: PassengerServiceDetails[] = [];
          let passengerProductClimateServiceDetail: PassengerServiceDetails[] = [];
          let passengerFlightOfferRef = pnrNumber + '-' + passengerId + '-' + flightRefIdsNotUN;

          let taxAmount: any = 0;
          let price: any = 0;
          let basePrice: any = 0;
          let priceCurrency = '';

          let flightPrice: any = 0;
          let flightTax: any = 0;
          let flightCurrency: any = '';
          let flightTotal: any = 0;
          let taxDetails: TaxDetails[] = [];

          this.orderItemList.forEach((orderItem: any) => {
            let serviceList = orderItem.SERVICE;
            let serviceListLength = serviceList.length;
            //map default price for flight  and free baggage detail
            if (passengerFlightOfferRef === orderItem.$.ORDERITEMID) {
              let priceDetail = orderItem.PRICEDETAIL[0];
              if (priceDetail.TAXES && priceDetail.TAXES.length > 0 && priceDetail.TAXES[0].BREAKDOWN && priceDetail.TAXES[0].BREAKDOWN.length > 0 && priceDetail.TAXES[0].BREAKDOWN[0].TAX) {
                priceDetail.TAXES[0].BREAKDOWN[0].TAX.forEach((tax: any) => {
                  if (tax.ADDLTAXTYPE && tax.TAXCODE && tax.AMOUNT && tax.AMOUNT[0]._ && tax.AMOUNT[0].$.CODE) {
                    taxDetails.push({
                      addLTaxType: tax.ADDLTAXTYPE[0],
                      taxCode: tax.TAXCODE[0],
                      amount: tax.AMOUNT[0]._,
                      amountCode: tax.AMOUNT[0].$.CODE
                    });
                  }
                });
                let simpleTax = priceDetail.TAXES[0].TOTAL[0]._;
                taxAmount += +simpleTax;
                totalTax += +simpleTax;
                flightTax += +simpleTax;
              }
              if (typeof priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._ !== 'undefined') {
                let simplePrice = priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;
                price += +simplePrice;
                totalPrice += +simplePrice;
                flightTotal += simplePrice;
              }
              if (typeof priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0].$ !== 'undefined') {
                let priceCode = priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0].$.CODE;
                priceCurrency = priceCode;
                flightCurrency = priceCode;
              }
              if (typeof priceDetail.BASEAMOUNT[0]._ !== 'undefined') {
                let flightBaseAmount = priceDetail.BASEAMOUNT[0]._;
                basePrice += +flightBaseAmount;
                flightPrice += +flightBaseAmount;
                totalBasePrice += +flightBaseAmount;
              }
              currency = priceCurrency;
              //map free bag
              if (serviceListLength > 0) {
                serviceList.forEach((service: any) => {
                  let passengerRef = service.PASSENGERREF[0];
                  if (passengerRef === passengerId) {
                    let serviceDefRef = '';
                    let flightRef = '';
                    if (typeof service.SERVICEDEFINITIONREF !== 'undefined') {
                      if (typeof service.SERVICEDEFINITIONREF[0].$ !== 'undefined') {
                        serviceDefRef = service.SERVICEDEFINITIONREF[0]._;
                        flightRef = service.SERVICEDEFINITIONREF[0].$.SEGMENTREF;
                      } else {
                        serviceDefRef = service.SERVICEDEFINITIONREF[0];
                        let serviceDefRefArray = serviceDefRef.split('-');
                        let serviceDefRefArrayLength = serviceDefRefArray.length;
                        flightRef = serviceDefRefArray[serviceDefRefArrayLength - 1];
                      }
                      let serviceListIndex: any = this.serviceDefinationListIds.indexOf(serviceDefRef);
                      let selectedService = this.serviceDefinationList[serviceListIndex];
                      let selectedFlightIndex = this.flightRefIds.indexOf(flightRef);
                      let selectedFlightDetail = this.flightsDetails[selectedFlightIndex];
                      let airLineCode = selectedFlightDetail.MARKETINGCARRIER[0].AIRLINEID[0];
                      let flightNumber = selectedFlightDetail.MARKETINGCARRIER[0].FLIGHTNUMBER[0];
                      let passengerBaggageDetail: PassengerServiceDetails = {
                        baggageName: selectedService.DESCRIPTIONS[0].DESCRIPTION[0].TEXT[0],
                        flightSegmentNumber: airLineCode + flightNumber,
                        offerItemId: orderItem.$.ORDERITEMID,
                        price: '0',
                        tax: '0',
                        currency: currency,
                        total: '0'
                      };
                      passengerBaggageDetails.push(passengerBaggageDetail);
                    }
                  }
                  let serviceItem = {
                    passengerRef: service.PASSENGERREF[0],
                    serviceId: service.$.SERVICEID,
                    serviceRef: service.SEGMENTREF ? service.SEGMENTREF[0] : ''
                  };

                  serviceItemList.push(serviceItem);
                });
                this.seatOfferIdList.push(orderItem.$.ORDERITEMID);
              }
            } else {
              //end
              //map paid seat,bag meals

              if (serviceListLength > 0) {
                serviceList.forEach((service: any) => {
                  let passengerRef = service.PASSENGERREF[0];
                  if (passengerRef === passengerId) {
                    // add price to base and tax
                    let priceDetail = orderItem.PRICEDETAIL[0];
                    let serviceTax: any = 0;
                    let serviceTotalAmount: any = 0;
                    let serviceBaseAmount: any = 0;
                    let serviceCurrency: any = '';

                    if (typeof priceDetail.TAXES !== 'undefined') {
                      serviceTax = priceDetail.TAXES[0].TOTAL[0]._;
                      taxAmount += +serviceTax;
                      totalTax += +serviceTax;
                    }
                    if (typeof priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._ !== 'undefined') {
                      serviceTotalAmount = priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;
                      price += +serviceTotalAmount;
                      totalPrice += +serviceTotalAmount;
                    }
                    if (typeof priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0].$ !== 'undefined') {
                      serviceCurrency = priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0].$.CODE;
                      priceCurrency = serviceCurrency;
                    }
                    if (typeof priceDetail.BASEAMOUNT[0]._ !== 'undefined') {
                      serviceBaseAmount = priceDetail.BASEAMOUNT[0]._;
                      basePrice += +serviceBaseAmount;
                      totalBasePrice += +serviceBaseAmount;
                    }
                    currency = priceCurrency;

                    let serviceDefRef = '';
                    let flightRefs: string[] = [];

                    if (typeof service.SERVICEDEFINITIONREF !== 'undefined') {
                      if (typeof service.SERVICEDEFINITIONREF[0].$ !== 'undefined') {
                        serviceDefRef = service.SERVICEDEFINITIONREF[0]._;
                        flightRefs.push(service.SERVICEDEFINITIONREF[0].$.SEGMENTREF);
                      } else {
                        serviceDefRef = service.SERVICEDEFINITIONREF[0];
                        let serviceDefRefArray = serviceDefRef.split('-');
                        flightRefs.push(serviceDefRefArray[serviceDefRefArray.length]);
                      }

                      let orderId = orderItem.$.ORDERITEMID;

                      let matches = orderId.match(/FS/g);
                      if (matches && matches.length > 1) {
                        let orderIdArray = orderId.split('-');
                        orderIdArray.forEach((segment: string) => {
                          if (segment.startsWith('FS')) {
                            flightRefs.push(segment);
                          }
                        });
                      } else {
                        let orderIdArray = orderId.split('-');
                        if (orderIdArray.length > 2) {
                          flightRefs = [orderIdArray[2]];
                        }
                      }

                      let flightSegmentNumbers = new Set<string>();

                      flightRefs.forEach((ref) => {
                        let serviceListIndex: any = this.serviceDefinationListIds.indexOf(serviceDefRef);
                        let selectedService = this.serviceDefinationList[serviceListIndex];

                        let selectedFlightIndex = this.flightRefIds.indexOf(ref);
                        if (selectedFlightIndex !== -1) {
                          let selectedFlightDetail = this.flightsDetails[selectedFlightIndex];
                          let airLineCode = selectedFlightDetail.MARKETINGCARRIER[0].AIRLINEID[0];
                          let flightNumber = selectedFlightDetail.MARKETINGCARRIER[0].FLIGHTNUMBER[0];

                          flightSegmentNumbers.add(`${airLineCode}${flightNumber}`);
                        }
                      });

                      let flightSegmentNumber = Array.from(flightSegmentNumbers).join('  ');

                      let serviceListIndex: any = this.serviceDefinationListIds.indexOf(serviceDefRef);
                      let selectedService = this.serviceDefinationList[serviceListIndex];

                      if (serviceDefRef.split('-')[0] === 'BAG') {
                        let passengerBaggageDetail: PassengerServiceDetails = {
                          baggageName: selectedService.DESCRIPTIONS[0].DESCRIPTION[0].TEXT[0],
                          flightSegmentNumber: flightSegmentNumber,
                          offerItemId: orderItem.$.ORDERITEMID,
                          price: serviceBaseAmount,
                          tax: serviceTax,
                          currency: serviceCurrency,
                          total: serviceTotalAmount
                        };
                        passengerBaggageDetails.push(passengerBaggageDetail);
                      } else if (serviceDefRef.split('-')[0] === 'CARB') {
                        let passengerProductClimateServiceDetails: PassengerServiceDetails = {
                          baggageName: selectedService.$.SERVICEDEFINITIONID.split('-')[1],
                          flightSegmentNumber: flightSegmentNumber,
                          offerItemId: orderItem.$.ORDERITEMID,
                          price: serviceBaseAmount,
                          tax: serviceTax,
                          currency: serviceCurrency,
                          total: serviceTotalAmount
                        };
                        passengerProductClimateServiceDetail.push(passengerProductClimateServiceDetails);
                      } else if (serviceDefRef.split('-')[0] === 'DISABILITY') {
                        let passengerDisablityServiceDetails: PassengerServiceDetails = {
                          baggageName: selectedService.DESCRIPTIONS[0].DESCRIPTION[0].TEXT[0],
                          flightSegmentNumber: flightSegmentNumber,
                          offerItemId: orderItem.$.ORDERITEMID,
                          price: serviceBaseAmount,
                          tax: serviceTax,
                          currency: serviceCurrency,
                          total: serviceTotalAmount
                        };
                        passengerDisablityServiceDetail.push(passengerDisablityServiceDetails);
                      } else if (serviceDefRef.split('-')[0] === 'MEAL') {
                        let passengerMealDetail: PassengerServiceDetails = {
                          baggageName: selectedService.DESCRIPTIONS[0].DESCRIPTION[0].TEXT[0],
                          flightSegmentNumber: flightSegmentNumber,
                          offerItemId: orderItem.$.ORDERITEMID,
                          price: serviceBaseAmount,
                          tax: serviceTax,
                          currency: serviceCurrency,
                          total: serviceTotalAmount
                        };
                        passengerMealDetails.push(passengerMealDetail);
                      }
                    }
                  }
                });
              }

              //end
            }
          });

          //map passenger selected seat detail
          let boundIndex = 0;

          boundFlightList.forEach((boundFlight: any) => {
            let boundFlightRefArray = boundFlight.SEGMENTREFERENCES[0].split(' ');
            let flightIndex = 0;
            boundFlightRefArray.forEach((flightRef: any) => {
              let seatRef = 'SEAT-' + passengerId + '-' + flightRef;
              let serviceIndex: any = this.seatServiceRefs.indexOf(seatRef);
              if (serviceIndex !== -1) {
                let selectedSeatService = this.seatServiceList[serviceIndex];
                let selectedSeatDetails = selectedSeatService.SELECTEDSEAT[0].SEAT[0];
                let seatRow = selectedSeatDetails.ROW[0];
                let seatCol = selectedSeatDetails.COLUMN[0];
                let selectedOrderItemIndex = this.offerItemIds.indexOf(pnrNumber + '-' + seatRow + seatCol + '-' + passengerId + '-' + flightRef);
                let selectedOrderItem = this.orderItemList[selectedOrderItemIndex];
                let priceDetail = selectedOrderItem.PRICEDETAIL[0];
                let seatPrice = priceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;

                let passengerSeatDetail: PassengerSeatDetails = {
                  seatRowNumber: seatRow,
                  seatCoulmnName: seatCol,
                  seatPrice: seatPrice,
                  boundOfferIndex: boundIndex,
                  flightIndex: flightIndex,
                  flightNumber: boundAirlineOffers[boundIndex].flightsDetails[flightIndex].airlineId + boundAirlineOffers[boundIndex].flightsDetails[flightIndex].airlineNumber
                };
                let yourBookingScreenFlightPassengerSeatDetail: YourBookingScreenFlightPassengerSeatDetail = {
                  passengerId: passengerId,
                  passengerType: passenger.PTC[0],
                  selectedRowNumber: selectedSeatDetails.ROW[0],
                  selectedColumnName: selectedSeatDetails.COLUMN[0],
                  selectedSeatPrice: '0',
                  selectedOfferItemRef: '',
                  selectedDeckIndex: '',
                  descriptions: [],
                  price: '',
                  currency: ''
                };
                passengerSeatDetails.push(passengerSeatDetail);

                if (boundAirlineOffers[boundIndex].flightsDetails[flightIndex].passengerSeatDetail) {
                  boundAirlineOffers[boundIndex].flightsDetails[flightIndex].passengerSeatDetail.push(yourBookingScreenFlightPassengerSeatDetail);
                }

                boundAirlineOffers[boundIndex].flightsDetails[flightIndex].isSeatAlreadyAdded = true;
              }
              flightIndex++;
            });
            boundIndex++;
          });
          //end of map passenger selected seat detail
          //map passenger ticket
          let passengerTicketDetails: PassengerTicketDetail[] = [];
          let passengerTicketLength = this.ticketDocsList.length;

          if (passengerTicketLength > 0) {
            this.ticketDocsList.forEach((ticketDocument: any) => {
              if (ticketDocument.PASSENGERREFERENCE[0] === passengerId) {
                if (ticketDocument.TICKETDOCUMENT[0].TYPE[0] !== 'T') {
                  if (ticketDocument.TICKETDOCUMENT[0].COUPONINFO[0].REASONFORISSUANCE[0].DESCRIPTION[0] === 'PREPAID SEAT CHARGE NON-INTERLINEABLE') {
                    ticketDocument.TICKETDOCUMENT[0].TYPE[0] = 'D';
                  } else if (ticketDocument.TICKETDOCUMENT[0].COUPONINFO[0].REASONFORISSUANCE[0].DESCRIPTION[0] === 'PREPAID ADDITIONAL BAGGAGE') {
                    ticketDocument.TICKETDOCUMENT[0].TYPE[0] = 'J';
                  } else if (ticketDocument.TICKETDOCUMENT[0].COUPONINFO[0].REASONFORISSUANCE[0].DESCRIPTION[0] === 'DIRECT PURCHASE OF SUSTAINABLE AVIATION FUEL') {
                    ticketDocument.TICKETDOCUMENT[0].TYPE[0] = 'Q';
                  } else {
                    ticketDocument.TICKETDOCUMENT[0].TYPE[0] = 'M';
                  }
                }
                let couponInfoDetails: CouponInfo[] = [];
                let additionalCouponInfo: AdditionalCouponInfo;
                if (typeof ticketDocument.TICKETDOCUMENT !== 'undefined') {
                  ticketDocument.TICKETDOCUMENT.forEach((ticketDoc: any) => {
                    ticketDoc.COUPONINFO.forEach((couponInfo: any) => {
                      if (
                        typeof couponInfo.INCONNECTIONWITHINFO !== 'undefined' &&
                        typeof couponInfo.INCONNECTIONWITHINFO[0].INCONNECTIONDOCNBR !== 'undefined' &&
                        typeof couponInfo.INCONNECTIONWITHINFO[0].INCONNECTONCPNNBR !== 'undefined'
                      ) {
                        additionalCouponInfo = {
                          inConnectionDocNbr: couponInfo.INCONNECTIONWITHINFO[0].INCONNECTIONDOCNBR[0],
                          inConnectonCpnNbr: couponInfo.INCONNECTIONWITHINFO[0].INCONNECTONCPNNBR[0],
                          rfic: couponInfo.REASONFORISSUANCE[0].RFIC[0],
                          code: couponInfo.REASONFORISSUANCE[0].CODE[0],
                          description: couponInfo.REASONFORISSUANCE[0].DESCRIPTION[0]
                        };
                      }
                      if (
                        typeof couponInfo.COUPONNUMBER[0] !== 'undefined' &&
                        typeof couponInfo.FAREBASISCODE !== 'undefined' &&
                        typeof couponInfo.FAREBASISCODE[0] !== 'undefined' &&
                        typeof couponInfo.STATUS[0] !== 'undefined'
                      ) {
                        couponInfoDetails.push({
                          couponNumber: couponInfo.COUPONNUMBER[0],
                          fareBasisCode: couponInfo.FAREBASISCODE[0].CODE[0],
                          status: couponInfo.STATUS[0],
                          additionalCouponInfo: additionalCouponInfo
                        });
                      } else {
                        couponInfoDetails.push({
                          couponNumber: couponInfo.COUPONNUMBER[0],
                          status: couponInfo.STATUS[0],
                          additionalCouponInfo: additionalCouponInfo
                        });
                      }
                    });
                  });
                }
                let reportingType = '';
                if (ticketDocument && typeof ticketDocument.TICKETDOCUMENT !== 'undefined' && typeof ticketDocument.TICKETDOCUMENT[0].REPORTINGTYPE !== 'undefined') {
                  reportingType = ticketDocument.TICKETDOCUMENT[0].REPORTINGTYPE[0];
                }
                let passengerTicketDetail: PassengerTicketDetail = {
                  ticketType: ticketDocument.TICKETDOCUMENT[0].TYPE[0],
                  ticketNumber: ticketDocument.TICKETDOCUMENT[0].TICKETDOCNBR[0],
                  reportingType: reportingType,
                  couponInfo: couponInfoDetails
                };
                passengerTicketDetails.push(passengerTicketDetail);
              }
            });
          }
          yourBookingFlightPrice += +basePrice;
          yourBookingTaxPrice += +taxAmount;
          yourBookingTotalPrice += +price;
          //end
          let passengerDetail: passengerScreenPassenger = {
            passengerOtherDetails: {
              passengerBaggageDetails: passengerBaggageDetails,
              passengerTicketDetails: passengerTicketDetails,
              passengerSeatDetails: passengerSeatDetails,
              passengerMealDetails: passengerMealDetails,
              passengerProductClimateServiceDetail: passengerProductClimateServiceDetail,
              passengerDisablityServiceDetail: passengerDisablityServiceDetail,
              passengerSelectedBaggageDetail: [],
              passengerSelectedMealDetails: [],
              passengerSelectedDisablityServiceDetail: [],
              passengerSelectedSeatDetails: [],
              passengerSelectedProductClimateServiceDetail: []
            },
            passengerStatus: true,
            passengerName: passengerContactDetail.GIVENNAME[0],
            passengerSurName: passengerContactDetail.SURNAME[0],
            passengerGender: passengerContactDetail.GENDER && passengerContactDetail.GENDER[0],
            passengerNameTitle: passengerContactDetail.NAMETITLE[0],
            passengerDOB: passengerContactDetail.BIRTHDATE && passengerContactDetail.BIRTHDATE[0],
            passengerType: passenger.PTC[0],
            passengerId: passengerId,
            basePrice: basePrice,
            taxPrice: taxAmount,
            totalPrice: price,
            currency: priceCurrency,
            flightPrice: flightPrice,
            flightTax: flightTax,
            flightTotal: flightTotal,
            flightCurrency: flightCurrency,
            taxDetails: taxDetails,
            identity: passenger.IDENTITYDOCUMENT && passenger.IDENTITYDOCUMENT[0].IDENTITYDOCUMENTTYPE[0],
            idnumber: passenger.IDENTITYDOCUMENT && passenger.IDENTITYDOCUMENT[0].IDENTITYDOCUMENTNUMBER[0],
            issuingCountry: passenger.IDENTITYDOCUMENT && passenger.IDENTITYDOCUMENT[0].ISSUINGCOUNTRYCODE[0],
            expiryDate: passenger.IDENTITYDOCUMENT && passenger.IDENTITYDOCUMENT[0].EXPIRYDATE[0]
          };
          passengerDetails.push(passengerDetail);
        });
      }
      if (yourBookingOrderItemList.length > 0) {
        yourBookingOrderItemList.forEach((orderItem: any) => {
          OrderItemID.push(orderItem.$.ORDERITEMID);
        });
        // console.log('OrderItemID', OrderItemID);
      }
      let isDisrupted = false;
      let disruptedDetails = {
        displayAccept: false,
        displayReshop: false,
        displayCancel: false,
        displayCallAirline: false
      };
      let distruptedOrderItem: any = [];
      if (typeof this.yourBookingScreenOrderView['EDIST:AUGMENTATIONPOINT'] !== 'undefined') {
        isDisrupted = true;
        this.yourBookingScreenOrderView['EDIST:AUGMENTATIONPOINT'][0].INVOLCHANGES[0].ORDERITEM.forEach((orderItem: any) => {
          distruptedOrderItem.push(orderItem.ORDERITEMID[0]);
        });
        let actionCodeList = this.yourBookingScreenOrderView['EDIST:AUGMENTATIONPOINT'][0].INVOLCHANGES[0].ORDERITEM[0].SELLERFOLLOWUPACTION[0].ACTIONCODE;
        actionCodeList.includes('ACCEPT') ? (disruptedDetails.displayAccept = true) : '';
        actionCodeList.includes('RESHOP') ? (disruptedDetails.displayReshop = true) : '';
        actionCodeList.includes('CANCEL') ? (disruptedDetails.displayCancel = true) : '';
        actionCodeList.includes('Call Airline') ? (disruptedDetails.displayCallAirline = true) : '';
      }
      this.booking = {
        bookingAgent: bookingAgent,
        boundAirlineOffer: boundAirlineOffers,
        priceDetail: {
          totalTax: yourBookingTaxPrice,
          price: yourBookingTotalPrice,
          currency: currency,
          flightPrice: yourBookingFlightPrice,
          seatPrice: 0
        },
        isDisrupted: isDisrupted,
        disruptedDetails: {
          displayAccept: disruptedDetails.displayAccept,
          displayReshop: disruptedDetails.displayReshop,
          displayCancel: disruptedDetails.displayCancel,
          displayCallAirline: disruptedDetails.displayCallAirline,
          distruptedOrderItem: distruptedOrderItem
        },
        pnrNumber: pnrNumber,
        owner: bookingAgent,
        bookingStatus: bookingStatus,
        paymentLimitTime: paymentTimeLimit,
        OrderItem: OrderItemID,
        seatOfferIdList: this.seatOfferIdList
      };

      this.passengerDetailScreenData = {
        bookingPassengerDetailType: 'your-booking-screen-passenger',
        isMapped: true,
        passengerDetail: passengerDetails,
        totalTax: totalTax,
        totalPrice: totalPrice,
        currency: currency,
        pnrNumber: pnrNumber,
        owner: bookingAgent,
        totalBasePrice: totalBasePrice,
        activePassengerIndex: 0
      };
    }

    let yourBookingScreenData: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    yourBookingScreenData.isMapped = true;
    yourBookingScreenData.booking = this.booking;
    yourBookingScreenData.selectedSeatItem = [];
    yourBookingScreenData.serviceList = serviceItemList;
    this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);
    this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreenData);

    let findOrdersScreenData: FindOrdersScreen = this.sandboxPageStateService.getFindOrderScreenData();
    findOrdersScreenData.isYourBookingMapped = yourBookingScreenData.isMapped;
    findOrdersScreenData.isYourBookingStatus = yourBookingScreenData.booking.bookingStatus;
    this.sandboxPageStateService.updateFindOrderScreen(findOrdersScreenData);

    let patchSandboxSourceData = { sandboxScreen: 'your-booking-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  mapYourReshopBookingScreen(yourBookingScreenOrderData: any) {
    let changeBookingScreenData = this.sandboxPageStateService.getChangeBookingScreenData();
    this.booking = {} as Booking;
    let bookingStatus = changeBookingScreenData.bookingStatus;
    let boundAirlineOffers: BoundAirlineOffer[] = [];
    let currency = '';
    let boundFlightList = this.yourBookingScreenDataLists['FLIGHTLIST'][0]['FLIGHT'];
    let boundFlightSegmentList = this.yourBookingScreenDataLists['FLIGHTSEGMENTLIST'][0]['FLIGHTSEGMENT'];
    let boundFlightListLength = boundFlightList.length;
    let OriginDestinationList = this.yourBookingScreenDataLists['ORIGINDESTINATIONLIST'];
    let pnrNumber = changeBookingScreenData.pnr;
    let bookingAgent = changeBookingScreenData.selectedOfferItem.offerOwner;
    let yourBookingOrderItem = yourBookingScreenOrderData.RESHOPOFFER[0].ADDOFFERITEM[0];
    let yourBookingOrderItemList = yourBookingScreenOrderData.RESHOPOFFER[0].ADDOFFERITEM;

    let paymentTimeLimit: any = '';
    if (typeof yourBookingScreenOrderData.RESHOPOFFER[0].PAYMENTTIMELIMITDATETIME !== 'undefined') {
      let paymentLimit: any = yourBookingScreenOrderData.RESHOPOFFER[0].PAYMENTTIMELIMITDATETIME[0];
      (paymentTimeLimit = this.datePipe.transform(paymentLimit, 'd-MMM-y h:mm')), (bookingStatus = 'HOLD');
    }
    if (boundFlightListLength > 0) {
      boundFlightList.forEach((boundFlight: any) => {
        let boundAirlineOffer = {} as BoundAirlineOffer;
        boundAirlineOffer = this.mapFlightDetails(boundFlight.SEGMENTREFERENCES[0], boundFlightSegmentList);
        let orginDestinationKey = '';
        this.destinationList.forEach((destination: any) => {
          let flightRefArr = destination.FLIGHTREFERENCES[0].split(' ');
          let flightRefIndex: any = flightRefArr.indexOf(boundFlight.$.FLIGHTKEY);
          if (flightRefIndex !== -1) {
            orginDestinationKey = destination.$.ORIGINDESTINATIONKEY;
          }
        });
        boundAirlineOffer.originDestinationKey = orginDestinationKey;
        boundAirlineOffer.depatureAirportCode = this.destinationList[0].DEPARTURECODE[0];
        boundAirlineOffer.arrivalAirportCode = this.destinationList[0].ARRIVALCODE[0];
        boundAirlineOffer.depatureDate = boundAirlineOffer.flightsDetails[0].segmentDepartureDate;
        boundAirlineOffers.push(boundAirlineOffer);
      });
      if (bookingStatus !== 'HOLD') {
        if (boundAirlineOffers[0].boundFlightStatus === 'Confirmed') {
          bookingStatus = 'CONFIRMED';
        } else if (boundAirlineOffers[0].boundFlightStatus === 'Cancelled') {
          bookingStatus = 'CANCELLED';
        }
      }
      let totalTax = 0;
      let totalPrice = 0;
      let yourBookingPassengerList = this.yourBookingScreenDataLists.PASSENGERLIST[0].PASSENGER;
      let yourBookingPassengerListLength = yourBookingPassengerList.length;
      let passengerDetails: passengerScreenPassenger[] = [];
      let OrderItemID: OrderItem[] = [];
      let flightsRefs = this.flightRefIds.join('-');
      let yourBookingFlightPrice: any = 0;
      let yourBookingTaxPrice: any = 0;
      let yourBookingTotalPrice: any = 0;
      if (yourBookingOrderItemList.length > 0) {
        yourBookingOrderItemList.forEach((orderItem: any) => {
          OrderItemID.push(orderItem.$.ORDERITEMID);
        });
      }
      this.booking = {
        bookingAgent: bookingAgent,
        boundAirlineOffer: boundAirlineOffers,
        priceDetail: {
          totalTax: yourBookingTaxPrice,
          price: yourBookingTotalPrice,
          currency: currency,
          flightPrice: yourBookingFlightPrice,
          seatPrice: 0
        },
        pnrNumber: pnrNumber,
        owner: 'BA',
        bookingStatus: bookingStatus,
        paymentLimitTime: paymentTimeLimit,
        OrderItem: OrderItemID,
        isDisrupted: false,
        disruptedDetails: {
          displayAccept: false,
          displayReshop: false,
          displayCancel: false,
          displayCallAirline: false,
          distruptedOrderItem: []
        },
        seatOfferIdList: this.seatOfferIdList
      };

      //this.isYourBookingScreenMapped = true;
    }

    let yourBookingScreenData: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    yourBookingScreenData.isMapped = true;
    yourBookingScreenData.booking = this.booking;
    yourBookingScreenData.selectedSeatItem = [];
    this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

    let findOrdersScreenData: FindOrdersScreen = this.sandboxPageStateService.getFindOrderScreenData();
    findOrdersScreenData.isYourBookingMapped = yourBookingScreenData.isMapped;
    findOrdersScreenData.isYourBookingStatus = yourBookingScreenData.booking.bookingStatus;
    this.sandboxPageStateService.updateFindOrderScreen(findOrdersScreenData);

    let patchSandboxSourceData = { sandboxScreen: 'your-booking-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  mapFlightDetails(flightRefIds: any, boundFlightSegmentList: any) {
    let totalConfirmedFlight: any = 0;
    let totalCancelledFlight: any = 0;
    let orderCreateViewRules: orderCreateViewRules[] = [];
    let ruleLabel = '';
    let penaltyRemark = '';
    let changeRuleLabel = '';
    let changePenaltyRemark = '';
    let cancellationRuleLabel = '';
    let cancellationPenaltyRemark = '';
    let flightsDetails: FlightDetail[] = [];
    let boundFlightRefArray = flightRefIds.split(' ');
    boundFlightRefArray.forEach((flightRef: any) => {
      let flightDetailIndex: any = this.flightRefIds.indexOf(flightRef);
      if (typeof flightDetailIndex !== 'undefined') {
        let selectedFlightDetail = boundFlightSegmentList[flightDetailIndex];
        let depatureDetail = selectedFlightDetail.DEPARTURE[0];
        let arrivalDetail = selectedFlightDetail.ARRIVAL[0];
        let marketingCarrier = selectedFlightDetail.MARKETINGCARRIER[0];
        let operatingCarrier = selectedFlightDetail.OPERATINGCARRIER[0];
        let fDetail = selectedFlightDetail.FLIGHTDETAIL[0];
        let fDuriation = '';
        let fSegmentType = '';
        if (typeof fDetail.FLIGHTDURATION !== 'undefined') {
          fDuriation = fDetail.FLIGHTDURATION[0].VALUE[0];
        }
        if (fDetail.FLIGHTSEGMENTTYPE) {
          fSegmentType = fDetail.FLIGHTSEGMENTTYPE[0];
          if (fSegmentType === 'HK') {
            totalConfirmedFlight++;
          } else if (fSegmentType === 'GK') {
            totalCancelledFlight++;
          }
        }

        //------------------------------ rules mapping ---------------------------

        let flightDetail: FlightDetail = {
          departureDate: this.datePipe.transform(depatureDetail.DATE[0], 'dd-MMM'),
          departureTimeIn24H: depatureDetail.TIME[0],
          departureAirportName: depatureDetail.AIRPORTNAME[0],
          departureAirportCode: depatureDetail.AIRPORTCODE[0],
          arrivalDate: this.datePipe.transform(arrivalDetail.DATE[0], 'dd-MMM'),
          segmentDepartureDate: this.datePipe.transform(arrivalDetail.DATE[0], 'dd-M-YYYY'),
          arrivalTimeIn24H: arrivalDetail.TIME[0],
          arrivalAirportName: arrivalDetail.AIRPORTNAME[0],
          arrivalAirportCode: arrivalDetail.AIRPORTCODE[0],
          airlineId: marketingCarrier.AIRLINEID[0],
          airlineName: marketingCarrier.NAME[0],
          operatingCarrier: operatingCarrier.NAME[0],
          airlineNumber: marketingCarrier.FLIGHTNUMBER[0],
          duriation: fDuriation,
          economyType: selectedFlightDetail.CLASSOFSERVICE ? selectedFlightDetail.CLASSOFSERVICE[0].MARKETINGNAME[0]._ : '',
          flightType: selectedFlightDetail.CLASSOFSERVICE ? selectedFlightDetail.CLASSOFSERVICE[0].CODE[0] : '',
          flightSegmentType: fSegmentType,
          passengerSeatDetail: [],
          isSeatAlreadyAdded: false,
          flightRef: flightRef,
          departureDateWithYear: depatureDetail.DATE[0]
        };
        flightsDetails.push(flightDetail);
      }
    });

    let postDepatureRules: Rule[] = [];
    let preDepatureRules: Rule[] = [];
    let noShowRules: Rule[] = [];
    if (this.penaltyRulesIds.length > 0) {
      this.penaltyRulesIds.forEach((ruleRef: any) => {
        let rulesIndex: any = this.rulesIds.indexOf(ruleRef);
        let selectedRules = this.rulesList[rulesIndex];
        let details = selectedRules.DETAILS[0].DETAIL[0];

        if (typeof details.AMOUNTS !== 'undefined') {
          if (details.TYPE[0] === 'Change') {
            changeRuleLabel = details.TYPE[0];
            changePenaltyRemark = details.AMOUNTS[0].AMOUNT[0].APPLICABLEFEEREMARKS[0].REMARK[0];
          } else if (details.TYPE[0] === 'Cancellation') {
            cancellationRuleLabel = details.TYPE[0];
            cancellationPenaltyRemark = details.AMOUNTS[0].AMOUNT[0].APPLICABLEFEEREMARKS[0].REMARK[0];
          }
        }
      });

      let orderCreateViewRule: orderCreateViewRules = {
        changeRuleLabel: changeRuleLabel,
        changePenaltyRemark: changePenaltyRemark,
        cancellationRuleLabel: cancellationRuleLabel,
        cancellationPenaltyRemark: cancellationPenaltyRemark
      };
      orderCreateViewRules.push(orderCreateViewRule);
    } else {
      if (this.fareRulesIds.length > 0) {
        let fareRulesIndex: any = this.fareRulesIds.indexOf(flightRefIds);
        let selectedFareSegment = this.fareRulesSegmentList[fareRulesIndex];
        if (typeof selectedFareSegment.FARERULES !== 'undefined') {
          let rulesRefsArr = selectedFareSegment.FARERULES[0].PENALTY[0].$.REFS.split(' ');
          rulesRefsArr.forEach((ruleRef: any) => {
            let rulesIndex: any = this.rulesIds.indexOf(ruleRef);
            let selectedRules = this.rulesList[rulesIndex];
            let details = selectedRules.DETAILS[0].DETAIL[0];
            let ruleType = details.APPLICATION[0];
            let ruleLabel = details.TYPE[0];
            let changePenaltyRemark = '';
            let cancellationPenaltyRemark = '';
            let changePenaltyAmount = '';
            let cancellationPenaltyAmount = '';
            let changeRuleLable = '';
            let cancellationRuleLabel = '';
            if (typeof details.AMOUNTS !== 'undefined') {
              let penaltyAmountDetail = details.AMOUNTS[0].AMOUNT[0].CURRENCYAMOUNTVALUE[0];
              let penaltyAmount = penaltyAmountDetail._ + '' + penaltyAmountDetail.$.CODE;
              if (ruleLabel === 'Change') {
                changeRuleLable = ruleLabel;
                changePenaltyRemark = 'Time/date changes permitted at any time before each flight departure for a change fee. ';
                changePenaltyAmount = penaltyAmount;
              } else if (ruleLabel === 'Cancellation') {
                cancellationRuleLabel = ruleLabel;
                cancellationPenaltyRemark = 'Cancelelation subject a fee. ';
                cancellationPenaltyAmount = penaltyAmount;
              }
            } else {
              if (ruleLabel === 'Change') {
                changeRuleLable = ruleLabel;
                changePenaltyRemark = 'No Changes are permitted';
              } else if (ruleLabel === 'Cancellation') {
                cancellationRuleLabel = ruleLabel;
                cancellationPenaltyRemark = 'There are no refunds except for any Government & airport taxes';
              }
            }
            let rule: Rule = {
              changeRuleLable: changeRuleLable,
              cancellationRuleLabel: cancellationRuleLabel,
              changePenaltyRemark: changePenaltyRemark,
              cancellationPenaltyRemark: cancellationPenaltyRemark,
              changePenaltyAmount: changePenaltyAmount,
              cancellationPenaltyAmount: cancellationPenaltyAmount
            };
            if (ruleType == '2') {
              preDepatureRules.push(rule);
            } else if (ruleType == '1') {
              noShowRules.push(rule);
            } else if (ruleType == '3') {
              postDepatureRules.push(rule);
            }
          });
        }
      }
    }

    let boundFlightStatus = '';
    if (totalConfirmedFlight === 0 && totalCancelledFlight > 0) {
      boundFlightStatus = 'Cancelled';
    } else if (totalCancelledFlight === 0 && totalConfirmedFlight > 0) {
      boundFlightStatus = 'Confirmed';
    }
    this.airlineOfferBase = {
      flightsDetails: flightsDetails,
      postDepatureRules: postDepatureRules,
      preDepatureRules: preDepatureRules,
      noShowRules: noShowRules,
      rule: orderCreateViewRules,
      displayRule: false,
      depatureAirportCode: '',
      arrivalAirportCode: '',
      depatureDate: '',
      boundFlightStatus: boundFlightStatus,
      originDestinationKey: ''
    };
    return this.airlineOfferBase;
  }

  mapPenaltyIds(penaltyList: any) {
    this.rulesIds = [];
    let penaltyListLength = penaltyList.length;
    if (penaltyListLength > 0) {
      penaltyList.forEach((penalty: any) => {
        this.rulesIds.push(penalty.$.OBJECTKEY);
      });
    }
  }
  mapOrderItemIds(offerItems: any) {
    this.offerItemIds = [];
    this.seatServiceRefs = [];
    this.seatServiceList = [];
    let offerItemsLength = offerItems.length;
    if (offerItemsLength > 0) {
      offerItems.forEach((offerItem: any) => {
        this.offerItemIds.push(offerItem.$.ORDERITEMID);
        let offerServices = offerItem.SERVICE;
        if (typeof offerServices !== 'undefined') {
          offerServices.forEach((offerService: any) => {
            let selectedSeats = offerService.SELECTEDSEAT;
            if (typeof offerService.SELECTEDSEAT !== 'undefined') {
              this.seatServiceRefs.push(selectedSeats[0].SERVICEDEFINITIONREF[0]);
              this.seatServiceList.push(offerService);
            }
          });
        }
      });
    }
  }

  mapReshopOfferItemIds(offerItems: any) {
    this.offerItemIds = [];
    this.seatServiceRefs = [];
    this.seatServiceList = [];
    let offerItemsLength = offerItems.length;
    if (offerItemsLength > 0) {
      offerItems.forEach((offerItem: any) => {
        this.offerItemIds.push(offerItem.$.OFFERITEMID);
        let offerServices = offerItem.SERVICE;
        if (typeof offerServices !== 'undefined') {
          offerServices.forEach((offerService: any) => {
            // let selectedSeats = offerService.SELECTEDSEAT;
            // if(typeof offerService.SELECTEDSEAT !== 'undefined'){
            //   this.seatServiceRefs.push(selectedSeats[0].SERVICEDEFINITIONREF[0]);
            //   this.seatServiceList.push(offerService);
            // }
          });
        }
      });
    }
  }
  mapServiceDeinationIds(serviceDefinationList: any) {
    this.serviceDefinationListIds = [];
    let serviceDefinationLength = serviceDefinationList.length;
    if (serviceDefinationLength > 0) {
      serviceDefinationList.forEach((serviceDefination: any) => {
        this.serviceDefinationListIds.push(serviceDefination.$.SERVICEDEFINITIONID);
      });
    }
  }
  mapFareRulesId(fareComponent: any) {
    this.fareRulesIds = [];
    let fareComponentLength = fareComponent.length;
    if (fareComponentLength > 0) {
      fareComponent.forEach((fare: any) => {
        this.fareRulesIds.push(fare.SEGMENTREFS[0]);
      });
    }
  }

  /*mapOrderItems(orderItems: any) {
    this.orderItemIds = [];
    let orderItemsLength = orderItems.length;
    if (orderItemsLength > 0) {
      orderItems.forEach((orderItem: any) => {
        this.orderItemIds.push(orderItem.$.ORDERITEMID);
      });
    }
  }*/

  mapFlightIds(flightSegmentList: any) {
    this.flightRefIds = [];
    let flightSegmentListLength = flightSegmentList.length;
    if (flightSegmentListLength > 0) {
      flightSegmentList.forEach((flightSegment: any) => {
        if (typeof flightSegment.FLIGHTDETAIL[0].FLIGHTSEGMENTTYPE !== 'undefined' && flightSegment.FLIGHTDETAIL[0].FLIGHTSEGMENTTYPE[0] !== 'UN') {
          this.flightRefIdsNotUN.push(flightSegment.$.SEGMENTKEY);
        }
        this.flightRefIds.push(flightSegment.$.SEGMENTKEY);
      });
    }
  }

  toggleRule(boundOfferIndex: any) {
    if (this.yourBookingScreen.booking!.boundAirlineOffer[boundOfferIndex].displayRule) {
      this.yourBookingScreen.booking!.boundAirlineOffer[boundOfferIndex].displayRule = false;
    } else {
      this.yourBookingScreen.booking!.boundAirlineOffer[boundOfferIndex].displayRule = true;
    }
  }
  targetRules(target: any, boundOfferIndex: any) {
    this.targetRule = target + boundOfferIndex;
    // return target+boundOfferIndex;
  }

  //seat selection function
  async manageSeats(flightIndex: any, boundOfferIndex: any) {
    let flightSegmentNumber = '';
    let selectedFlight: any = this.yourBookingScreen.booking.boundAirlineOffer[boundOfferIndex].flightsDetails[flightIndex];
    flightSegmentNumber = selectedFlight.airlineId + selectedFlight.airlineNumber;
    let operatedBy = selectedFlight.operatingCarrier;
    if (!['BRITISH AIRWAYS', 'BA CITYFLYER', 'BA EUROFLYER'].includes(operatedBy?.toUpperCase())) {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: ' Unable to return seat map for the requested flight(s) - request seat at check-in' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      return;
    }
    this.initYourBookingScreenSeatSelectionRequest();
    await this.apiService.getXMLResponse(this.sandboxPageStateService.SEAT_SELECTION_SCREEN_URL, JSON.stringify(this.seatSelectionScreenRequest), new Map(), {
      headers: new HttpHeaders({
        soapAction: 'SeatAvailability17_2_V2'
      }),
      responseType: 'text'
    });

    let seatSelectionScreen: SeatSelectionScreen = {} as SeatSelectionScreen;

    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      seatSelectionScreen.xml = this.sandboxPageStateService.getResponseFromMap(this.sandboxPageStateService.SEAT_SELECTION_SCREEN_URL);
      (seatSelectionScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(seatSelectionScreen.xml!)), (seatSelectionScreen.boundOfferIndex = boundOfferIndex);
      seatSelectionScreen.flightSegmentIndex = flightIndex;
      seatSelectionScreen.flightNumber = flightSegmentNumber;
      seatSelectionScreen.bookingType = 'your-booking-screen-seat';
      seatSelectionScreen.passengerDetail = [];
      seatSelectionScreen.deckDetails = [];

      this.sandboxPageStateService.updateSeatSelectionScreenData(seatSelectionScreen);
      this.sandboxPageStateService.updateYourBookingScreenData(this.yourBookingScreen);

      let patchSandboxSourceData = { mainMenu: 'seat-selection', sideMenu: 'none' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  initYourBookingScreenSeatSelectionRequest() {
    let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenData.booking;
    let jsonRequest = '';
    let findOrderScreenRequest = {} as FindOrderScreenRequest;
    let createOrderScreenRequest = {} as OfferPriceScreenOrderCreateRequest;
    let orderRepriceRequest = {} as ChangeDatetimeReshopReprice;
    if (this.yourBookingScreenBookingType === 'pre-booking') {
      jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.OFFER_PRICE_SCREEN_ORDER_CREATE_URL);
      createOrderScreenRequest = JSON.parse(jsonRequest);
    } else if (this.yourBookingScreenBookingType === 'post-booking') {
      jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.FIND_ORDER_SCREEN_URL);
      findOrderScreenRequest = JSON.parse(jsonRequest);
    } else if (this.yourBookingScreenBookingType === 'post-booking-reshop') {
      jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.CHANGE_BOOKING_ORDER_REPRICE_URL);
      orderRepriceRequest = JSON.parse(jsonRequest);
    }

    this.seatSelectionScreenRequest['S:Envelope'] = {} as SEnvelopeSeatSelection;
    this.seatSelectionScreenRequest['S:Envelope'].$ = {};
    this.seatSelectionScreenRequest['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.seatSelectionScreenRequest['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.seatSelectionScreenRequest['S:Envelope']['SOAP-ENV:Header'] = '';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body'] = {} as SBodySeatSelection;
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ = {} as SeatAvailabilityRQ;
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$ = {};
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$.Version = '17.2';
    if (this.yourBookingScreenBookingType === 'pre-booking') {
      this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Document = createOrderScreenRequest['S:Envelope']['S:Body']?.OrderCreateRQ.Document;
      this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Party = createOrderScreenRequest['S:Envelope']['S:Body']?.OrderCreateRQ.Party;
    } else if (this.yourBookingScreenBookingType === 'post-booking') {
      this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Document = findOrderScreenRequest['S:Envelope']['S:Body']?.OrderRetrieveRQ.Document;
      this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Party = findOrderScreenRequest['S:Envelope']['S:Body']?.OrderRetrieveRQ.Party;
    } else if (this.yourBookingScreenBookingType === 'post-booking-reshop') {
      this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Document = orderRepriceRequest['S:Envelope']['S:Body']?.OrderReshopRQ.Document;
      this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Party = orderRepriceRequest['S:Envelope']['S:Body']?.OrderReshopRQ.Party;
    }

    delete this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Query;
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Query = {
      Order: {
        $: {
          OrderID: bookingDetail?.pnrNumber,
          Owner: bookingDetail?.owner
        }
      }
    };
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.DataLists = {
      PassengerList: {
        Passenger: this.loadPassengerDetail()
      }
    };
  }
  cancelSeats(flightIndex: any, boundOfferIndex: any) {
    this.cancelSeatSelectedBoundIndex = boundOfferIndex;
    this.cancelSeatSelectedFlightIndex = flightIndex;
  }
  deleteSeats() {
    this.initDeleteSeatOrderChangeRequest();
  }
  async initDeleteSeatOrderChangeRequest() {
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_ISSUE_TICKET_REQUEST_TEMPLATE);
    this.orderChangeRemoveSeat = JSON.parse(jsonRequestTemplate as any);
    this.orderChangeRemoveSeat['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeRemoveSeat['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeRemoveSeat['S:Envelope']['SOAP-ENV:Header'] = '';
    this.orderChangeRemoveSeat['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.orderChangeRemoveSeat['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.orderChangeRemoveSeat['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.orderChangeRemoveSeat['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
    this.orderChangeRemoveSeat['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = [];
    this.orderChangeRemoveSeat['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
    this.orderChangeRemoveSeat['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
      Delete: {
        OrderItemID: this.loadDeleteSeat()
      }
    };
    delete this.orderChangeRemoveSeat['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder;
    delete this.orderChangeRemoveSeat['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList;
    delete this.orderChangeRemoveSeat['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
    this.loadOrderChangePassengerDetail();
    await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeRemoveSeat), this.orderChangeInputParams, {
      headers: new HttpHeaders({
        soapAction: 'OrderChange17_2_V4'
      }),
      responseType: 'text'
    });
    this.updateRemoveSeatResponseXML(this.sandboxPageStateService.ORDER_CHANGE_URL);
  }
  loadOrderChangePassengerDetail() {
    let passengerDetailScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    let passengerDetail = passengerDetailScreenData.passengerDetail;
    let passengerDetails: orderChangePassenger[] = [];

    let passengerDetailLength: any = passengerDetail.length;
    if (passengerDetailLength > 0) {
      passengerDetail.forEach((passenger: passengerScreenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail = {} as orderChangePassenger;
        passengerDetail.$ = {
          PassengerID: passengerId
        };
        passengerDetail.PTC = passenger.passengerType;
        passengerDetail.Birthdate = passenger.passengerDOB;
        passengerDetail.Individual = {
          Gender: passenger.passengerGender,
          NameTitle: this.capitalizeFirstLetter(passenger.passengerNameTitle),
          GivenName: passenger.passengerName,
          Surname: passenger.passengerSurName
        };
        passengerDetails.push(passengerDetail);
      });
      this.orderChangeRemoveSeat['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = passengerDetails;
    }
  }
  capitalizeFirstLetter(words: any) {
    const result = words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
    return result;
  }
  updateRemoveSeatResponseXML(url: any) {
    let orderChangeXMLData = this.sandboxPageStateService.getResponseFromMap(url);
    let orderChangeJSONData = this.xmlToJsonParserService.parseXMLToJSON(orderChangeXMLData);
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.xml = orderChangeXMLData;
      yourBookingScreenData.jsonData = orderChangeJSONData;
      yourBookingScreenData.isMapped = false;
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

      let patchSandboxSourceData: any = { mainMenu: 'none' };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      setTimeout(() => {
        let patchSandboxSourceData: any = '';
        patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 200);
    }
  }
  loadDeleteSeat() {
    let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
    let boundDetails = yourBookingScreenData.booking.boundAirlineOffer;
    let selectedFlight = boundDetails[this.cancelSeatSelectedBoundIndex].flightsDetails[this.cancelSeatSelectedFlightIndex];
    let passengerDetail = selectedFlight.passengerSeatDetail;
    let passengerDetailLength = passengerDetail.length;
    let OrderItemIDs: any[] = [];
    if (passengerDetailLength > 0) {
      passengerDetail.forEach((passenger: any) => {
        let seatRefs = yourBookingScreenData.booking.pnrNumber + '-' + passenger.selectedRowNumber + passenger.selectedColumnName + '-' + passenger.passengerId + '-' + selectedFlight.flightRef;
        OrderItemIDs.push(seatRefs);
      });
    }
    return OrderItemIDs;
  }
  loadPassengerDetail() {
    let passengerDetails: PassengerSeatSelection[] = [];
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerDetailScreenData();
    let passengerScreenPassengerDetail = passengerScreenDetail.passengerDetail;
    let passengerDetailLength = passengerScreenPassengerDetail.length;
    if (passengerDetailLength > 0) {
      passengerScreenPassengerDetail.forEach((passenger: passengerScreenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail: PassengerSeatSelection = {
          $: {
            PassengerID: passengerId
          },
          PTC: passenger.passengerType,
          Birthdate: passenger.passengerDOB,
          Individual: {
            Gender: passenger.passengerGender,
            NameTitle: passenger.passengerNameTitle,
            GivenName: passenger.passengerName,
            Surname: passenger.passengerSurName
          }
        };
        if (typeof passenger.infantRef !== 'undefined') {
          passengerDetail.InfantRef = passenger.infantRef;
        }
        passengerDetails.push(passengerDetail);
      });
    }
    return passengerDetails;
  }
  //end
  getFlightLogoUrl(airlineName: string) {
    const flightLogoUrl = this.flightLogoMap.get(airlineName);
    if (flightLogoUrl) {
      return flightLogoUrl;
    }
    return '';
  }
}
